export enum MessageType {
  Success = 1,
  Error = 2,
  Warning = 3,
  Info = 4,
}
